import { call, put, takeLatest } from 'redux-saga/effects';
import ApiManager from 'network/ApiManager';
import StatusCode from 'network/StatusCode';
import { authReadMyInformationRequested } from './authDuck';

// Actions
// Fetch
const FETCH_USER_CONSENT_REQUESTED =
  'memo-web/user-consent/FETCH_USER_CONSENT_REQUESTED';
const FETCH_USER_CONSENT_SUCCEED =
  'memo-web/user-consent/FETCH_USER_CONSENT_SUCCEED';
const FETCH_USER_CONSENT_FAILED =
  'memo-web/user-consent/FETCH_USER_CONSENT_FAILED';
// Update
const UPDATE_USER_CONSENT_REQUESTED =
  'memo-web/user-consent/UPDATE_USER_CONSENT_REQUESTED';
const UPDATE_USER_CONSENT_SUCCEED =
  'memo-web/user-consent/UPDATE_USER_CONSENT_SUCCEED';
const UPDATE_USER_CONSENT_FAILED =
  'memo-web/user-consent/UPDATE_USER_CONSENT_FAILED';

// Reducer
const initialState = {
  pending: false,
  data: null,
  error: null,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    // Fetch
    case FETCH_USER_CONSENT_REQUESTED:
      return {
        ...state,
        pending: true,
        error: null,
      };
    case FETCH_USER_CONSENT_SUCCEED:
      return {
        ...state,
        pending: false,
        data: action.data,
      };
    case FETCH_USER_CONSENT_FAILED:
      return {
        ...state,
        pending: false,
        error: action.error,
      };
    // Update
    case UPDATE_USER_CONSENT_REQUESTED:
      return {
        ...state,
        pending: true,
        error: null,
      };
    case UPDATE_USER_CONSENT_SUCCEED:
      return {
        ...state,
        pending: false,
        data: action.data,
      };
    case UPDATE_USER_CONSENT_FAILED:
      return {
        ...state,
        pending: false,
        error: action.error,
      };
    default:
      return state;
  }
}

// Action Creators
// Fetch
export function fetchUserConsentRequested() {
  return {
    type: FETCH_USER_CONSENT_REQUESTED,
  };
}
export function fetchUserConsentSucceed(data) {
  return {
    type: FETCH_USER_CONSENT_SUCCEED,
    data: data,
  };
}
export function fetchUserConsentFailed(error) {
  return { type: FETCH_USER_CONSENT_FAILED, error: error };
}
// Update
export function updateUserConsentRequested(isConfirmed) {
  return {
    type: UPDATE_USER_CONSENT_REQUESTED,
    isConfirmed: isConfirmed,
  };
}
export function updateUserConsentSucceed(data) {
  return {
    type: UPDATE_USER_CONSENT_SUCCEED,
    data: data,
  };
}
export function updateUserConsentFailed(error) {
  return { type: UPDATE_USER_CONSENT_FAILED, error: error };
}

// Sagas
function* readUserConsent(action) {
  try {
    const { status, data } = yield call(ApiManager.readUserConsent);

    yield put(fetchUserConsentSucceed(data));
  } catch (error) {
    yield put(fetchUserConsentFailed(error));
  }
}

function* updateUserConsent(action) {
  try {
    const {
      status,
      data: { result },
    } = yield call(ApiManager.updateUserConsent, action.isConfirmed);

    yield put(updateUserConsentSucceed(result));
  } catch (error) {
    yield put(updateUserConsentFailed(error));
  }
}

export function* saga() {
  yield takeLatest(FETCH_USER_CONSENT_REQUESTED, readUserConsent);
  yield takeLatest(UPDATE_USER_CONSENT_REQUESTED, updateUserConsent);
}
